/**
 * shiboruu 用デザイントークン。
 *
 * ルール:
 * - このファイルにはコンポーネント固有の意味を持たせないこと
 * - 数値ベースではなく、役割ベースの命名を優先すること
 * - アプリコードから import される前提であり、ここから他を import しないこと
 */

export const tokens = {
  colors: {
    /** 無彩色 */
    neutral: {
      white: '#FFFFFF',
      text: '#333333',
      subText: '#666666',
      gray: '#A6A6A6',
    },

    /** リンク */
    link: {
      default: '#006E8A',
    },

    /** 状態色 */
    status: {
      rejected: '#D4504A',
      approved: '#2CC878',
      warning: '#FF9900',
      increase: '#59C27D',
      decrease: '#D5526C',
    },

    /** 汎用色（意味を固定したくない場合の逃げ道） */
    utility: {
      green: '#2D7C2E',
      brown: '#B85A00',
      orange: '#FF7A00',
      ink: '#8C8C8C',
    },

    /** サーフェス / 背景 */
    surface: {
      base: '#FFFFFF',
      lpSectionTop: '#FFF0F4',
      lpSectionBottom: '#FAB6C9',
      slideMessageBackground: '#F3F4F7',
    },
  },

  gradients: {
    /** テキスト用グラデーション */
    text: {
      brandAccentPink: 'linear-gradient(140deg, #E7006C 0%, #FC7DB8 50%)',
      brandLogoText: 'linear-gradient(90deg, #DA49F9, #39C7E8)',
    },

    /** ボタン用グラデーション */
    button: {
      primaryFill: 'linear-gradient(90deg, #FFCB8B, #EE008F)',
      primaryBorder: 'linear-gradient(140deg, #EE008F, #FFCB8B)',
    },

    /** ブランドカラー（円形サンプルの見た目と合わせたグラデ） */
    brand: {
      mainPrimary: 'linear-gradient(90deg, #FFCB8B, #EE008F)',
      mainSecondary: 'linear-gradient(90deg, #FFF0F4, #FAB6C9)',
      mainTertiary: 'linear-gradient(90deg, #FF4DA1, #E7006C)',
    },

    /** セクション背景用グラデーション */
    surface: {
      lpSection: 'linear-gradient(to bottom, #FFF0F4, #FAB6C9)',
    },
  },

  radii: {
    /** 完全に丸めたい要素用（pill ボタンなど） */
    pill: '1000px',
  },

  space: {
    /** 余白スケール（px） */
    xs: '4px',
    s: '8px',
    m: '12px',
    l: '20px',
    xl: '28px',
  },

  fontSizes: {
    /** フォントサイズ（px） */
    xs: '11px',
    s: '12px',
    m: '13px',
    button: '14px',
    heroCatchphrase: 'clamp(24px, 6vw, 40px)',
  },
} as const

export type Tokens = typeof tokens
